export default class CompanypriceetcService {
  getAll(params) {
      const queryParams = Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&');
      return fetch('https://api.tradersr.com/api/companypriceetc?' + queryParams).then(res => res.json())
  }
}